import styled from 'styled-components';

export const DrawerSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const DrawerSectionContent = styled.div`
    margin-top: 1.6rem;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.6rem;
    color: ${({ theme }) => theme.colors.grey[700]};

    ol,
    ul {
        padding-inline-start: 0.5rem;
        margin: 0;
    }
`;
